import { RegisteredComponent } from "@builder.io/sdk-react";
import { DLD_FIELD, DLT_FIELD } from "../../commonFields";

export const cveIndexTableBlockConfig: Omit<RegisteredComponent, "component"> =
  {
    name: "CVE Index",
    friendlyName: "CVE Index",
    noWrap: true,
    inputs: [
      {
        name: "columnTitles",
        friendlyName: "Column Titles",
        type: "object",
        defaultValue: {
          severity: "Severity",
          advisory: "Advisory",
          advisoryId: "Advisory ID",
          published: "Published",
          updated: "Updated",
          fixedVersion: "Fixed Version",
        },
        subFields: [
          {
            name: "severity",
            type: "string",
            localized: true,
          },
          {
            name: "advisory",
            type: "string",
            localized: true,
          },
          {
            name: "advisoryId",
            friendlyName: "Advisory ID",
            type: "string",
            localized: true,
          },
          {
            name: "published",
            type: "string",
            localized: true,
          },
          {
            name: "updated",
            type: "string",
            localized: true,
          },
          {
            name: "fixedVersion",
            friendlyName: "Fixed Version",
            type: "string",
            localized: true,
          },
        ],
      },
      {
        name: "showMore",
        type: "object",
        defaultValue: {
          text: "Show More Advisories",
        },
        subFields: [
          {
            name: "text",
            type: "string",
            localized: true,
            required: true,
          },
          DLD_FIELD,
          DLT_FIELD,
        ],
      },
      {
        name: "notFound",
        type: "object",
        defaultValue: {
          message: 'Sorry, We couldn\'t find any matches for "{keyword}".',
          suggestion:
            "<p>Search tips:</p><ul><li>Check spelling</li><li>Try rephrasing your search query or adjusting your filters</li></ul>",
        },
        subFields: [
          {
            name: "message",
            type: "string",
            localized: true,
            required: true,
            helperText:
              'Use {keyword} as a placeholder for the search term. E.g. "No results for {keyword}".',
          },
          {
            name: "suggestion",
            type: "richText",
            localized: true,
            required: true,
          },
        ],
      },
    ],
  };
